module.exports = __webpack_public_path__ + "assets/person-xs-49ced50f87e738e1b4067ab945c4f34e.svg";